var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemeCounterCircleShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 562,
    viewBox: "0 0 584 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.919 25.8195C409.544 23.4638 398.916 19.5097 394.148 17.8271L390.783 24.1369L410.974 32.1292C411.956 30.1662 413.919 26.156 413.919 25.8195Z",
    fill: "#0E9462"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435.791 36.7564C431.47 34.3023 422.174 29.1081 417.446 27.3179L413.939 33.5498L432.005 44.3281C433.031 42.3878 435.783 37.0928 435.791 36.7564Z",
    fill: "#0E9462"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M457.666 50.2171C453.345 47.763 444.262 41.1467 439.534 39.3565L436.027 45.5884L453.039 57.3682C454.064 55.4279 457.658 50.5536 457.666 50.2171Z",
    fill: "#0E9462"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M471.126 51.0583L464.816 59.892L478.698 63.2572L471.126 51.0583Z",
    fill: "#0E9462"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M472.5 73.3527H487.952C496.365 81.9059 513.528 99.5171 514.874 101.536H526.231C542.496 124.251 576.625 180.029 583.019 221.421L577.13 229.834C586.375 256.729 583.025 322.665 582.18 331.185C582.232 331.201 582.234 331.21 582.177 331.21C582.178 331.202 582.179 331.194 582.18 331.185C581.609 331.007 575.035 329.948 572.082 329.948C577.55 303.448 575.363 249.689 568.296 229.834C565.351 220.159 556.275 180.414 535.065 146.966C513.191 112.473 498.689 99.2866 495 94.6594C490.991 89.6328 478.949 79.5222 472.5 73.3527Z",
    fill: "#0E9462"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M577.971 347.195L569.138 344.671L564.09 366.124L572.923 369.069L577.971 347.195Z",
    fill: "#0E9462"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M571.661 371.592L562.827 369.069L556.518 389.26L565.351 393.046L571.661 371.592Z",
    fill: "#0E9462"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M564.511 395.149L555.677 392.625L546.844 411.554L555.677 415.34L564.511 395.149Z",
    fill: "#0E9462"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M546.842 430.484L538.009 427.96L532.961 438.056L540.112 440.579L546.842 430.484Z",
    fill: "#0E9462"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M538.85 443.103L531.699 440.159L527.492 446.048L532.961 450.675L538.85 443.103Z",
    fill: "#0E9462"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M523.707 465.398L516.976 462.032L512.77 467.501L518.238 471.707L523.707 465.398Z",
    fill: "#0E9462"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M515.714 473.811L511.929 470.025L511.087 469.183L506.881 474.652L511.087 478.858L515.714 473.811Z",
    fill: "#0E9462"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M509.404 480.962L504.356 476.755L499.309 481.382L503.936 486.009L509.404 480.962Z",
    fill: "#0E9462"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M479.538 509.986L475.332 503.677L458.506 516.296L463.974 522.606L479.538 509.986Z",
    fill: "#0E9462"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M459.348 525.13L455.141 518.82L437.895 530.178L442.522 536.908L459.348 525.13Z",
    fill: "#0E9462"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M439.158 539.011L434.531 532.281L416.863 541.956L421.07 549.107L439.158 539.011Z",
    fill: "#0E9462"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M397.934 559.623L407.188 549.948L410.974 559.623H397.934Z",
    fill: "#0E9462"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M360.916 8.15208C358.392 7.73143 355.027 6.6097 353.344 6.46948L352.924 11.9379L360.075 13.6205L360.916 8.15208Z",
    fill: "#0E9462"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M350.401 6.04906C347.877 5.62841 344.933 4.92733 343.25 4.78711V10.6762L349.98 11.5175L350.401 6.04906Z",
    fill: "#0E9462"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M341.145 4.36644C338.621 3.94579 335.677 3.24471 333.994 3.10449V8.99357L340.725 9.83487L341.145 4.36644Z",
    fill: "#0E9462"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M315.486 1.15967C312.962 0.739019 309.597 0.299884 307.914 0.159668V6.46984L315.486 6.89049V1.15967Z",
    fill: "#0E9462"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M305.39 0.159424C302.866 -0.261225 299.501 0.299658 297.818 0.159442V6.46944H305.39V0.159424Z",
    fill: "#0E9462"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M295.5 0.159424C292.977 -0.261225 289.683 0.299672 288 0.159456L287.725 6.46976H295.296L295.5 0.159424Z",
    fill: "#0E9462"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M275.525 8.65967V0.160156C274.179 0.160156 259.73 0.37948 253 0.659912L254 10.1597L275.525 8.65967Z",
    fill: "#0E9462"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 11.1602L249.5 1.16016C248.154 1.16016 237.334 2.63626 228.5 5.16016L230.095 15.7242L250.5 11.1602Z",
    fill: "#0E9462"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 16.1594L225.888 6.04883C224.542 6.04883 212.834 10.1355 204 12.6594L207.5 22.1594L227.5 16.1594Z",
    fill: "#0E9462"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.172 41.3833L154 46.1594C91.7445 86.1211 64.7804 125.092 46.6925 156.22C32.2222 181.123 18.5091 224.159 18.5091 239.93L12.1994 228.151C11.8628 222.767 20.1917 199.828 24.3982 189.031L18.5091 180.197C28.9412 143.517 71.9315 93.4035 92.1226 72.932L102.218 74.1939L150.172 41.3833Z",
    fill: "#0E9462"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22 368.159C23 367.826 25.4391 376.178 26 377.159L19.3652 379.335L17.5 374.659L16 370.159C18.5239 369.598 17.4998 369.658 22 368.159Z",
    fill: "#0E9462"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.151 380.61C27.4875 381.956 28.6934 385.517 29.2543 386.498L22.9445 388.602L20 381.871C22.5239 381.31 26.8145 379.264 27.151 380.61Z",
    fill: "#0E9462"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.151 389.61C31.4875 390.956 32.6934 394.517 33.2543 395.498L26.9445 397.602L24 390.871C26.5239 390.31 30.8145 388.264 31.151 389.61Z",
    fill: "#0E9462"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8044 411.975L35.3359 414.92L39.1218 421.229C40.9446 420.248 44.5061 418.285 44.1696 418.285C43.833 418.285 41.7859 414.078 40.8044 411.975Z",
    fill: "#0E9462"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8512 421.229L40.3828 424.174L44.1687 430.484C45.9915 429.502 49.553 427.539 49.2164 427.539C48.8799 427.539 46.8328 423.333 45.8512 421.229Z",
    fill: "#0E9462"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4775 430.063L45.4297 432.587L49.2155 438.896C51.0383 437.915 54.5998 435.952 54.2633 435.952C53.9268 435.952 51.459 432.166 50.4775 430.063Z",
    fill: "#0E9462"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M127.037 525.129L121.568 511.668C164.643 542.628 195.322 553.453 205.277 554.995C203.712 557.038 200.762 561.161 201.492 561.305C181.637 557.603 143.582 535.645 127.037 525.129Z",
    fill: "#0E9462"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5744 445.627L55.9473 450.254L67.7254 466.659L72.7732 461.612C71.0906 461.275 63.6592 450.955 60.5744 445.627Z",
    fill: "#0E9462"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4538 465.397L70.668 469.604L82.4461 486.009L88.3352 480.541C86.6526 480.204 78.2396 469.604 74.4538 465.397Z",
    fill: "#0E9462"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8608 483.906L86.6543 488.533L100.115 503.256L106.004 498.628C104.322 498.292 94.6466 488.112 90.8608 483.906Z",
    fill: "#0E9462"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 253.39L7.99233 243.295L12.1988 254.652L0 253.39Z",
    fill: "#0E9462"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7237 266.43H6.31077L5.04883 289.145H14.7237V266.43Z",
    fill: "#0E9462"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7237 291.669H5.04883L6.31077 312.281H15.565L14.7237 291.669Z",
    fill: "#0E9462"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5641 316.067H6.73047L9.25436 337.941H18.088L15.5641 316.067Z",
    fill: "#0E9462"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemeCounterCircleShape);
export default __webpack_public_path__ + "static/media/meme_counter_circle_shape.f980cb83b4fa38ec21f3c5c3a83bca8a.svg";
export { ForwardRef as ReactComponent };